import * as Rx from "rxjs/Rx";
import { Observable } from "rxjs";
import CornerstoneUtil from "../util/CornerstoneUtil";

export default class ImageService {
  private imageLoaderScheme: string;
  private imagePathsToLoad: Rx.Subject<string>;

  constructor(imageLoaderScheme: string) {
    this.imageLoaderScheme = imageLoaderScheme;
    this.imagePathsToLoad = new Rx.Subject();

    this.imagePathsToLoad
      .asObservable()
      .concatMap((imgPath) =>
        Observable.fromPromise(
          CornerstoneUtil.loadAndCacheImage(this.imageLoaderScheme, imgPath).catch((err) =>
            console.error("Error occurred when loading image ", imgPath, err)
          )
        )
      )
      .subscribe();
  }

  scheduleImageLoading(imgPath: string) {
    this.imagePathsToLoad.next(imgPath);
  }
}
